import { environment } from '@/environments/environment';

const getUserLocale = () => {
  const defaultLang = environment.language;
  const availableLanguage = ['en', 'nl'];

  const userLocale = navigator.language || defaultLang;
  const userLang = userLocale.split('-')[0].toLowerCase();

  const isAvailable = availableLanguage.includes(userLang);

  return isAvailable ? userLang : defaultLang;
};

export { getUserLocale };
